import React, {Component} from 'react'

class Footer extends Component {
    render() {
        return (
            <div id="footerIndex">
                © 2020 Unique Tutorials | <a href="/terms">Terms & Conditions</a>
            </div>
        )
    }
}

export default Footer